import UserExportInfoDTO from '@src/adapters/dto/user/UserExportInfoDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  jobId: string;
}

interface Result {
  userInfos: UserExportInfoDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/user/user_export',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetUserExportLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetUserExportLazy;
